<template>
  <div class="ticket">
    <div class="ticket-body" @click="ticketClick(ticket)" >
      <div class="ticket-status">
        <div>
          #{{ticket.ticketNumber}}
        </div>
        <div class="show-hand" :style="statusColor()" >
          {{ticket.status}}
        </div>
      </div>
      <div class="ticket-description show-hand" >
        <div @click="ticketClick(ticket)">
          {{ticket.title}}
        </div>
        <div>
          {{ticket.description}}
        </div>
      </div>
    </div>
   <div class="ticket-footer">
        <div class="ticket-square" @click="ticketPin(ticketIndex)" :class="ticket.isPin? 'ticket-pin-dark' : 'ticket-pin-light'">
        </div>
        <div class="ticket-square" @click="ticketStar(ticketIndex)" :class="ticket.isStar? 'ticket-star-dark' : 'ticket-star-light'">
        </div>
        <div class="ticket-square" @click="ticketMore()" :class="isMore? 'ticket-more-dark' : 'ticket-more-light'">
            <ul role="menu" :class="isMore ? 'dropdown-menu show' :  'dropdown-menu'" x-placement="right-start">
            <li data-v-abeadf28="">
                <a role="menuitem" target="_self" href="#" class="dropdown-item">Action</a>
            </li>
            <li data-v-abeadf28="">
                <a role="menuitem" target="_self" href="#" class="dropdown-item">Action 2</a>
            </li>
        </ul>
        </div>
        <div class="ticket-assign">
            <div class="img-container" v-if="ticket.assignedToPictureUrl">
            <img v-bind:src="ticket.assignedToPictureUrl" width="24" alt="picture" srcset="" />
            </div>
            <div class="no-image" v-if="!ticket.assignedToPictureUrl" :style="getRandomColor(true)">
                <p>{{assigneeShortName}}</p>
            </div>
            <div class="assigned-text">
            <span>assigned to</span>
            <div>{{ticket.assignedTo}}</div>
            </div>
        </div>
        <div class="ticket-assign">
            <div class="img-container" v-if="ticket.raisedByPictureUrl">
                <img v-bind:src="ticket.raisedByPictureUrl" width="24" alt="picture" srcset="" />
            </div>
            <div class="no-image" v-if="!ticket.raisedByPictureUrl" :style="getRandomColor()">
                <p>{{clientShortName}}</p>
            </div>
            <div class="assigned-text">
            <span>raised by</span>
            <div>{{ticket.client.clientName}}</div>
            </div>
        </div>
        <div class="ticket-priorty">
            <div class="priority-text">
            <span>priorty</span>
            <div :style="priorityColor()">{{ticket.priority}}</div>
            </div>
        </div>
        <div class="ticket-due-date">
            <div class="due-date-text">
            <span>due in</span>
            <div>{{(ticket.dueDate) ? moment(ticket.dueDate).add(1,'day').fromNow():"-"}}</div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
  //import Card from './Card.vue'
  import Moment from "moment";

  export default {
    name: 'ticket-card',
    components: {
      //Card
    },
    data() {
      return {
      isPin: false,
      isStar: false,
      isMore: false  
      }
    },
    props: {
     ticket: {type: Object,default: () => {}},
     ticketIndex: {type: Number}
    },
    computed: {
        caseDescription() {
            if( this.ticket.description.length > 50 ) {
            return this.ticket.description.substring(0,50) + "...";
            } else {
            return this.ticket.description || "";
            }
        },
        assigneeShortName() {
            let name = this.ticket.assignedTo.toUpperCase().split(" ")
            let firstLetter = name[0].charAt(0)
            return name.length > 1 ? (firstLetter + name[1].charAt(0)) : firstLetter
        },
        clientShortName() {
            let clientName = this.ticket.client.clientName.toUpperCase().split(" ")
            let firstLetter = clientName[0].charAt(0)
            return clientName.length > 1 ? (firstLetter + clientName[1].charAt(0)) : firstLetter
        }
    },
    methods: {
        getRandomColor(sortColorDesc) {
            let that = this
            const letters = "0123456789ABCDEF";
            var color = "#";
            let colorArr = [
                "d89385",
                "4543b2",
                "5bd992",
                "000f35",
                "1c87c9",
                "d12ef6"
            ]
            let index = sortColorDesc ? 5 - (this.ticketIndex % 6) : (this.ticketIndex % 6)
            color += colorArr[index]
           /* if(sortColorDesc) { //sortColorDesc is using for switch color for assigned to column if image not present
                switch() {
                  case 0:
                    color += 
                  break;
                  case 1:
                    color += 
                  break;
                  case 2:
                    color += 
                  break;
                  case 3:
                    color += 
                  break;
                  case 4:
                    color += 
                  break;
                  case 5:
                    color += 
                  break;
                }
            } else {
              switch(this.ticketIndex % 6) {
                  case 5:
                    color += "d89385"
                  break;
                  case 4:
                    color += "4543b2"
                  break;
                  case 3:
                    color += "5bd992"
                  break;
                  case 2:
                    color += "000f35"
                  break;
                  case 1:
                    color += "1c87c9"
                  break;
                  case 0:
                    color += "d12ef6"
                  break;
                }
            }*/
            
            return "background-color:" + color + ";";
        },
        moment(d) {
            return Moment(d);
        },
       ticketTime() {
        let t = this;
        let color;
        let days = -2;

        if( t.ticket.status === 'parked' ) {
          return "background-color:#edf7f7;";
        }

        if( t.ticket.status === 'complete' ) {
          return "background-color:#fff;";
        }

        if( t.ticket.dueDate ) {
          days = Moment().add(1,'day').diff(t.ticket.dueDate,'days');
        }
        if( days <= -1 ) {
          color = "#eee";
        } else if( days >= 1)  {
          color = "#ffe0e0"     // red
        } else {    
          color = "#fffccc"     // yellow
        }

        return "background-color:" + color + ";";
      },
      priorityColor() {
        let t = this;
        let color;
        if( t.ticket.priority === "normal") {
          color = "forestgreen";
        } else if( t.ticket.priority === "high" )  {
          color = "firebrick"
        } else if( t.ticket.priority === "low" )  {
          color = "lightgray"
        } else if( t.ticket.priority === "critical" )  {
          color = "fuchsia"
        } else {
          color = "black";
        }

        return "color:" + color + ";";
      },
      statusColor() {
        let t = this;
        let color;
        let status = t.ticket.status;

        if( status=== "open") {
          color = "forestgreen";
        } else if( status === "new" )  {
          color = "orange"
        } else if( status === "parked" )  {
          color = "lightgray"
        } else if( status === "in-process" )  {
          color = "fuchsia"
        } else {
          color = "black";
        }

        return "background-color:" + color + ";";
      },
      ticketClick( ticket ) {
        this.$emit( "select" , ticket._id );
      },
      ticketPin(ticketIndex) {
        this.$emit( "ticketPin" , ticketIndex );
        //this.isPin = !this.isPin;
      },
      ticketStar(ticketIndex) {
        this.$emit( "ticketStar" , ticketIndex );
       // this.isStar = !this.isStar;
      },
      ticketMore() {
        this.isMore = !this.isMore;
      }
    }
  }

</script>
<style lang="scss" scoped>
    .ticket {
        // vertical-align:top;
        //display:inline-block;
        display:flex;
        //    border-collapse:collapse;
        // padding:2px;
        height:70;
        width:100%;
        border-radius:.5em;
        margin-bottom:10px;
        background-color:#eee;
        flex-direction: column;
        border: 1px solid #eeeeee;
        overflow:hidden;
        box-shadow: 0px 0px 10px -7px #000;
        .ticket-body {
            display:flex;
            width:100%;
            background-color:#fff;
            flex-direction: row;
            padding-top: 10px;
            padding-bottom: 10px;
            // background-color:pink;
            .ticket-priority {
                vertical-align:top;
                border-radius:.25em;
                height:100%;
                width:10px;
                margin-left:3px;
            }
            .ticket-status {
            //    display:inline-block;
                height:100%;
                width:140px;
                padding:2px 0px 2px;
                // background-color:greenyellow;
                div:first-child {
                    font-size:.8em;
                    font-weight:800;
                    // padding-top:3px;
                    text-align:center;
                    // background-color:#eee;
                }
                div:nth-child(2) {
                    margin-top:.5em;
                    width:100%;
                    text-align:center;
                    font-size:.7em;
                    font-weight:700;
                    padding: 5px 5px;
                    border-radius:.25em;
                    color:white;
                    border-top-left-radius: 0;
                    border-bottom-left-radius: 0;
                    text-transform: uppercase;
                    box-sizing: border-box;
                //       background-color:coral;
                }
            }
            .ticket-description{
                // height:70px;
                width: 100%;
                text-align: left;
                padding-left: 15px; 
                color: #777;
                //width:78%;
                //    white-space:nowrap;
                overflow:hidden;
                // text-overflow:ellipsis;
                // background-color:gold;
                div:first-child {
                    height:22px;
                    //width:95%;
                    // padding-left:6px;
                    font-size:1em;
                    font-weight:700;
                    color:#686868;
                    white-space:nowrap;  
                    overflow:hidden;
                    text-overflow:ellipsis;
                    // background-color:#eee;
                }
                div:nth-child(2) {
                    height:18px;
                    //padding-left:16px;
                    // font-style:italic;
                    font-size:.9em;
                    width:100%;
                    white-space:nowrap;
                    overflow:hidden;
                    text-overflow:ellipsis;
                }
                div:nth-child(3) {
                    height:18px;
                    font-size:.9em;
                    // padding-left:16px;
                    width:100%;
                    white-space:nowrap;
                    overflow:hidden;
                    text-overflow:ellipsis;
                }
            }
        }
        .ticket-footer {
            vertical-align:bottom;
            display:flex;
            flex-direction: row;
            // height:48px;
            width:100%;
            border-style:solid;
            border-width: 1px 0 0 0;
            border-color: #eee;
            // background-color:fuchsia;
            background-color:#f9f9f9;
            .no-image {
                width: 32px;
                height: 32px;
                background: red;
                position: relative;
                border-radius: 50%;
                overflow: hidden;
                margin: 5px 10px;
                p {
                    font-weight: 900;
                    position: absolute;
                    transform: translate(-50%, -50%);
                    left: 50%;
                    top: 50%;
                    margin: 0;
                    padding: 0;
                    font-size: 13px;
                    font-family: Arial;
                    color: #fff;
                }
            }
            .ticket-square {
                vertical-align:top;
                display:inline-block;
                // height:48px;
                width:40px;
                color:gold;
                // background-color:black;
                font-size:24pt;
                vertical-align:middle;
                text-align:center;
                border-right: 1px solid #eee;
                cursor:pointer;
                background-size: 52%;
                background-repeat: no-repeat;
                background-position: center;
                position: relative;
                &.ticket-pin-light {
                  background-image: url('../assets/push-pin.svg');
                  &:hover{
                    background-image: url('../assets/push-pin-dark.svg');
                  }
                }
                &.ticket-pin-dark {
                  background-image: url('../assets/push-pin-dark.svg');
                }
                &.ticket-star-light {
                  background-image: url('../assets/star.svg');
                  &:hover{
                   background-image: url('../assets/star-dark.svg');
                  }
                }
                &.ticket-star-dark {
                  background-image: url('../assets/star-dark.svg');
                }
                &.ticket-more-light {
                  background-image: url('../assets/more.svg');
                  &:hover{
                   background-image: url('../assets/more-dark.svg');
                  }
                }
                &.ticket-more-dark {
                  background-image: url('../assets/more-dark.svg');
                }
                ul.dropdown-menu {
                   transform: translate3d(35px, -48px, 0px);
                   position: absolute;
                   top: 0px;
                   left: 0px;
                   will-change: transform;
                }
            }
            
            //  div:first-child {
                // vertical-align:top;
                // display:inline-block;
                // height:48px;
                // width:48px;
                // color:gold;
                // background-color:black;
            //  }

            // div:nth-child(2) {
            //   vertical-align:top;
            //   display:inline-block;
            //   height:48px;
            //   width:48px;
            //   background-color:greenyellow;
            // }

            //  div:nth-child(3) {
            //   vertical-align:top;
            //   display:inline-block;
            //   height:48px;
            //   width:48px;
            //   background-color:greenyellow;
            // }
            // div:nth-child(4) {
            //   vertical-align:top;
            //   display:inline-block;
            //   height:48px;
            //   width:200px;
            //   background-color:blue;
            // }
            // div:nth-child(5) {
            //   vertical-align:top;
            //   display:inline-block;
            //   height:48px;
            //   width:200px;
            //   background-color:gray;
            // }
            text-transform: capitalize;
            .ticket-assign {
                border-right: 1px solid #eee;
                display: flex;
                align-items: center;
                width: 24%;
                padding: 5px 0px;
                text-align: left;
                .img-container {
                    border-radius: 50%;
                    width: 32px;
                    height: 32px;
                    overflow: hidden;
                    margin: 5px 10px;
                    img {
                        width: 100%;
                        height: auto;
                    }
                }
                .assigned-text {
                    font-size: 0.85rem;
                    div {
                        font-weight: 700;
                    }
                }
            }
            .ticket-priorty {
                border-right: 1px solid #eee;
                display: flex;
                align-items: center; 
                width: 15%;
                padding-left: 10px;
                text-align: left;
                .priority-text {
                    font-size: 0.85rem;
                    div {
                        font-weight: 700;
                    }
                }
            }
            .ticket-due-date {
                border-right: 1px solid #eee;
                display: flex;
                align-items: center; 
                width: 15%;
                padding-left: 10px;
                text-align: left;
                .due-date-text {
                    font-size: 0.85rem;
                    div {
                        font-weight: 700;
                    }
                }
            }
        }
    }
</style>
